import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import { createLogger } from '../utils/logger';

const logger = createLogger('ProtectedRoute');

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuthContext();
  logger.debug('ProtectedRoute check', { isAuthenticated, isLoading });

  if (isLoading) {
    // Optional: Show a loading spinner or a blank page while auth state is being determined.
    // This prevents a flash of the login page before the user is redirected.
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    logger.debug('User not authenticated, redirecting to /');
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
